import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../context/ToastContext";
import { downloadFile } from "../../lib/download";

interface Props {
  path: string;
  fallbackName: string;
  method?: "GET" | "POST";
  body?: unknown;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

/** One-click download of a generated PDF / Excel / CSV file, with progress and error toasts. */
export function DownloadButton({ path, fallbackName, method, body, children, className = "btn-ghost", disabled }: Props) {
  const { t } = useTranslation();
  const { toast, toastError } = useToast();
  const [busy, setBusy] = useState(false);

  async function run() {
    setBusy(true);
    try {
      const name = await downloadFile(path, { method, body, fallbackName });
      toast(t("export.downloaded", { name }), "success");
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  }
  return (
    <button type="button" className={className} disabled={busy || disabled} onClick={run} aria-busy={busy}>
      {busy ? <span aria-hidden>⏳</span> : null}
      {children}
    </button>
  );
}
